<template>
  <div>
    <v-dialog v-model="value" persistent max-width="800">
      <v-card>
        <div class="text-xs-right" @click="oncancel">
          <v-btn small flat fab><v-icon>close</v-icon></v-btn>
        </div>
        <v-card-text>
          <v-stepper v-model="step" vertical class="elevation-0">
            <v-stepper-step step="1" :complete="step > 1">
              {{ $t('Coupon Info') }}
            </v-stepper-step>
            <v-stepper-content step="1">
              <v-card class="elevation-0 mb-5">
                <div class="form-control" :class="{ 'has-error': errors.has('couponname') }">
                  {{ $t('Coupon Name') }}
                  <input
                    v-model="coupon.name"
                    v-validate="'required'"
                    type="text"
                    maxlength="20"
                    :placeholder="$t('Coupon Name')"
                    name="couponname"
                    :data-vv-as="$t('Coupon Name')"
                  />
                  <span v-if="errors.has('couponname')" class="text-error">{{
                    errors.first('couponname')
                  }}</span>
                </div>
                <div class="form-control" :class="{ 'has-error': errors.has('couponcode') }">
                  {{ $t('Coupon Code') }}
                  <input
                    v-model="coupon.code"
                    v-validate="`required|excluded: ${excludeCoupons}`"
                    type="text"
                    maxlength="10"
                    :placeholder="$t('Coupon Code')"
                    :data-vv-as="$t('Coupon Code')"
                    style="text-transform: uppercase"
                    name="couponcode"
                    @blur="onBlurCode"
                  />
                  <span v-if="errors.has('couponcode')" class="text-error">{{
                    errors.first('couponcode')
                  }}</span>
                </div>
              </v-card>
              <v-btn color="primary" depressed @click="nextStep(2)">{{ $t('Next') }}</v-btn>
              <v-btn flat @click="oncancel">{{ $t('cancel') }}</v-btn>
            </v-stepper-content>

            <v-stepper-step step="2" :complete="step > 2">
              {{ $t('Coupon condition') }}
            </v-stepper-step>
            <v-stepper-content step="2">
              <v-card class="elevation-0 mb-5">
                <v-layout v-if="selectedBot.type === 'dtac-gaming'" wrap>
                  <v-flex xs12 sm6 class="pa-1">
                    <div class="caption">{{ $t('Type of discounts') }}</div>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    class="form-control pa-1"
                    :class="{ 'has-error': errors.has('promovalue') }"
                  >
                    <template>
                      <div class="caption">{{ $t('Minimum purchase of') }}</div>
                      <v-layout>
                        <v-flex>
                          <input
                            v-model="coupon.promovalue"
                            v-validate="'required|numeric'"
                            type="number"
                            min="0"
                            maxlength="5"
                            max="99999"
                            placeholder="Price"
                            name="promovalue"
                          />
                          <span v-if="errors.has('promovalue')" class="text-error">{{
                            errors.first('promovalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Baht') }}</v-flex>
                      </v-layout>
                    </template>
                  </v-flex>
                </v-layout>
                <v-layout v-else wrap>
                  <v-flex xs12 sm6 class="pa-1">
                    <div class="caption">{{ $t('Type of discounts') }}</div>
                    <v-radio-group v-model="coupon.promotype" :data-vv-as="$t('Type of discounts')">
                      <v-radio
                        :label="$t('Price discount')"
                        :value="'price'"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('Quantity discount')"
                        :value="'piece'"
                        color="primary"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    class="form-control pa-1"
                    :class="{ 'has-error': errors.has('promovalue') }"
                  >
                    <template v-if="coupon.promotype == 'price'">
                      <div class="caption">{{ $t('Minimum purchase of') }}</div>
                      <v-layout>
                        <v-flex>
                          <input
                            v-model="coupon.promovalue"
                            v-validate="'required|numeric'"
                            type="number"
                            min="0"
                            maxlength="5"
                            max="99999"
                            placeholder="Price"
                            name="promovalue"
                          />
                          <span v-if="errors.has('promovalue')" class="text-error">{{
                            errors.first('promovalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Baht') }}</v-flex>
                      </v-layout>
                    </template>
                    <template v-else>
                      <div class="caption">{{ $t('Minimum of ... items') }}</div>
                      <v-layout>
                        <v-flex>
                          <input
                            v-model="coupon.promovalue"
                            v-validate="'required|numeric'"
                            type="number"
                            min="0"
                            maxlength="5"
                            max="99999"
                            placeholder="Count"
                            name="promovalue"
                          />

                          <span v-if="errors.has('promovalue')" class="text-error">{{
                            errors.first('promovalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Items') }}</v-flex>
                      </v-layout>
                    </template>
                  </v-flex>
                </v-layout>
                <v-divider class="mb-3"></v-divider>

                <v-layout wrap>
                  <v-flex xs12 sm6 class="pa-1">
                    <div class="caption">{{ $t('Discount for') }}</div>
                    <v-radio-group v-model="coupon.discounttype" :data-vv-as="$t('Discount for')">
                      <v-radio
                        :label="$t('Discount price')"
                        :value="'price'"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('Discount percent')"
                        :value="'percent'"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        v-if="selectedBot.type !== 'dtac-gaming'"
                        :label="$t('Discount shipping fee')"
                        :value="'ship'"
                        color="primary"
                      ></v-radio>
                      <div v-if="selectedBot.type !== 'dtac-gaming'" style="display: flex">
                        <v-radio style="height: 28px" :value="'freeship'" color="primary">
                          <template slot="label">
                            {{ $t('Free Delivery') }}
                          </template>
                        </v-radio>
                        <v-checkbox
                          v-if="coupon.discounttype === 'freeship'"
                          v-model="coupon.exclude_shipping_list"
                          class="ml-3 mt-0 pa-0"
                          :label="$t('Except cash on delivery')"
                          color="primary"
                        ></v-checkbox>
                      </div>
                      <v-radio
                        v-if="selectedBot.type !== 'dtac-gaming'"
                        class="mt-2"
                        :label="$t('Free gift')"
                        :value="'giveaway'"
                        color="primary"
                      />
                    </v-radio-group>
                  </v-flex>
                  <v-flex v-if="coupon.discounttype != 'giveaway'" xs12 sm6 class="pa-1">
                    <template v-if="coupon.discounttype == 'price'">
                      <div class="caption">ลดราคา</div>
                      <v-layout>
                        <v-flex
                          class="form-control"
                          :class="{ 'has-error': errors.has('discountvalue') }"
                        >
                          <input
                            v-model="coupon.discountvalue"
                            v-validate="'required|numeric'"
                            type="number"
                            min="0"
                            maxlength="5"
                            max="99999"
                            placeholder="Price"
                            name="discountvalue"
                          />
                          <span v-if="errors.has('discountvalue')" class="text-error">{{
                            errors.first('discountvalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Baht') }}</v-flex>
                      </v-layout>
                    </template>
                    <template v-else-if="coupon.discounttype == 'percent'">
                      <div class="caption">{{ $t('Discount percent') }}</div>
                      <v-layout>
                        <v-flex
                          class="form-control"
                          :class="{ 'has-error': errors.has('discountvalue') }"
                        >
                          <input
                            v-model="coupon.discountvalue"
                            v-validate="'required|numeric|max_value:100|min_value:1'"
                            type="number"
                            min="0"
                            max="100"
                            maxlength="3"
                            placeholder="Price"
                            name="discountvalue"
                          />
                          <span v-if="errors.has('discountvalue')" class="text-error">{{
                            errors.first('discountvalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">%</v-flex>
                      </v-layout>
                    </template>
                    <template v-else-if="coupon.discounttype == 'ship'">
                      <div class="caption">{{ $t('Discount shipping fee') }}</div>
                      <v-layout>
                        <v-flex
                          class="form-control"
                          :class="{ 'has-error': errors.has('discountvalue') }"
                        >
                          <input
                            v-model="coupon.discountvalue"
                            v-validate="'required|numeric|min_value:1'"
                            type="number"
                            min="0"
                            maxlength="5"
                            max="99999"
                            placeholder="Price"
                            name="discountvalue"
                          />
                          <span v-if="errors.has('discountvalue')" class="text-error">{{
                            errors.first('discountvalue')
                          }}</span>
                        </v-flex>
                        <v-flex shrink class="pa-2">{{ $t('Baht') }}</v-flex>
                      </v-layout>
                    </template>
                    <template v-else>
                      <div class="caption">{{ $t('Discount shipping fee') }}</div>
                      <div class="pa-2">
                        {{ $t('Free Delivery') }}
                        {{ coupon.exclude_shipping_list ? $t('Except cash on delivery') : '' }}
                      </div>
                    </template>
                  </v-flex>
                  <v-flex v-else xs12>
                    <SelectGiftStock v-model="giveaway_product_ids" />
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn color="primary" depressed @click="nextStep(3)">{{ $t('Next') }}</v-btn>
              <v-btn flat @click="step = 1">{{ $t('Back') }}</v-btn>
            </v-stepper-content>

            <v-stepper-step step="3" :complete="step > 3">
              {{ $t('Limit number of coupon used') }} ({{ $t('Optional') }})
            </v-stepper-step>
            <v-stepper-content step="3">
              <v-card class="elevation-0 mb-5">
                <v-layout wrap>
                  <v-flex xs12 sm6 class="pa-1 form-control">
                    <div class="caption">{{ $t('1 person/ 1 time') }}</div>
                    <v-layout row wrap>
                      <toggle-button
                        style="margin-top: auto; margin-bottom: auto"
                        class="mr-3"
                        :value="coupon.onetimeuse"
                        :sync="true"
                        :color="$vuetify.theme.success"
                        :labels="{ checked: 'ON', unchecked: 'OFF' }"
                        @change="
                          coupon.onetimeuse = !coupon.onetimeuse
                          coupon.limit_used_per_user = 1
                        "
                      />
                      <div v-if="['dtac-gaming'].includes(selectedBot.type)">
                        <span>1 คน/ </span>
                        <input
                          v-model="coupon.limit_used_per_user"
                          class="px-1"
                          style="width: 30px; text-align: center"
                          :disabled="coupon.onetimeuse"
                          type="number"
                          maxlength="9999"
                        />

                        <span> ครั้ง</span>
                      </div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 class="pa-1 form-control">
                    <div class="caption">
                      {{ $t('Number of code that can be used in the campaign') }}
                    </div>
                    <v-layout>
                      <v-flex>
                        <input v-model="coupon.quantity" type="number" maxlength="9999" />
                      </v-flex>
                      <v-flex shrink>
                        <v-btn small fab flat class="my-0" @click="coupon.quantity = null">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider class="my-3" />
                {{ $t('Hide this coupon code') }}
                <toggle-button
                  class="ml-2"
                  :value="coupon.is_hidden"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  @change="coupon.is_hidden = !coupon.is_hidden"
                />
                <v-divider class="my-3" />
                {{ $t('first_time_purchase') }}
                <toggle-button
                  class="ml-2"
                  :value="coupon.first_time_purchase"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  @change="coupon.first_time_purchase = !coupon.first_time_purchase"
                />
                <v-divider class="my-3" />
                <div class="form-control" :class="{ 'has-error': errors.has('Expired date') }">
                  {{ $t('Validity for this promo code') }}

                  <!-- <v-layout class="mt-2"> -->
                  <!-- <v-flex class="pr-1"> -->
                  <div class="form-control mt-2">
                    <div class="caption">{{ $t('Turn-on Time') }}</div>
                    <v-layout wrap>
                      <v-flex
                        xs5
                        class="form-control"
                        :class="{ 'has-error': errors.has('startdate') }"
                      >
                        <v-menu
                          ref="openStartDate"
                          v-model="openStartDate"
                          :close-on-content-click="false"
                          full-width
                          max-width="290px"
                          color="primary"
                        >
                          <template #activator="{ on }">
                            <input
                              v-model="startDate"
                              type="text"
                              class="form-control browser-default"
                              :placeholder="$t('Date')"
                              readonly
                              clearable
                              small
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="startDate"
                            color="primary"
                            @input="openStartDate = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs3 class="pl-1">
                        <multiselect
                          v-model="startTimeHours"
                          class="time"
                          :options="optionsHours"
                          :searchable="false"
                          :close-on-select="true"
                          :show-labels="false"
                          :placeholder="$t('ชั่วโมง')"
                          :disabled="startDate == null"
                        ></multiselect>
                      </v-flex>
                      <v-flex xs3 class="pl-1">
                        <multiselect
                          v-model="startTimeMinute"
                          class="time"
                          :options="optionsMinute"
                          :searchable="false"
                          :close-on-select="true"
                          :show-labels="false"
                          :placeholder="$t('นาที')"
                          :disabled="startDate == null"
                        ></multiselect>
                      </v-flex>
                      <v-flex xs1>
                        <v-btn
                          fab
                          flat
                          small
                          color="primary"
                          style="height: 35px; width: 35px"
                          @click="
                            startDate = null
                            startTimeHours = '00'
                            startTimeMinute = '00'
                          "
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                  <!-- </v-flex>
                    <v-flex class="pl-1"> -->
                  <div class="form-control">
                    <div class="caption">{{ $t('Turn-off Time') }}</div>
                    <v-layout wrap>
                      <v-flex
                        class="form-control"
                        xs5
                        :class="{ 'has-error': errors.has('enddate') }"
                      >
                        <v-menu
                          ref="openEndDate"
                          v-model="openEndDate"
                          :close-on-content-click="false"
                          full-width
                          max-width="290px"
                          color="primary"
                        >
                          <template #activator="{ on }">
                            <input
                              v-model="endDate"
                              type="text"
                              class="form-control browser-default"
                              :placeholder="$t('Date')"
                              readonly
                              clearable
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="endDate"
                            color="primary"
                            @input="openEndDate = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs3 class="pl-1">
                        <!-- <v-flex xs3 class="pl-1"> -->
                        <multiselect
                          v-model="endTimeHours"
                          class="time"
                          :options="optionsHours"
                          :searchable="false"
                          :close-on-select="true"
                          :show-labels="false"
                          :placeholder="$t('ชั่วโมง')"
                          :disabled="endDate == null"
                        ></multiselect>
                      </v-flex>
                      <v-flex xs3 class="pl-1">
                        <multiselect
                          v-model="endTimeMinute"
                          class="time"
                          :options="optionsMinute"
                          :searchable="false"
                          :close-on-select="true"
                          :show-labels="false"
                          :placeholder="$t('Minutes')"
                          :disabled="endDate == null"
                        ></multiselect>
                      </v-flex>
                      <!-- </v-flex> -->
                      <v-flex xs1>
                        <v-btn
                          fab
                          flat
                          small
                          color="primary"
                          style="height: 35px; width: 35px"
                          @click="
                            endDate = null
                            endTimeHours = '00'
                            endTimeMinute = '00'
                          "
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                  <!-- </v-flex> -->
                  <!-- </v-layout> -->
                </div>
                <v-divider class="my-3" />
                <v-layout>
                  <v-flex>
                    {{ $t('Specific category') }}
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn small outline color="primary" @click="handleAddCategory">
                      <v-icon class="mr-2">add</v-icon> {{ $t('Add') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
                <div v-if="['dtac-gaming'].includes(selectedBot.type)">
                  <div v-if="selectedDtacGame.length == 0" class="text-xs-center my-3">
                    coupon for all game
                  </div>
                  <template v-else>
                    <v-card style="border: 1px solid #eee">
                      <template v-for="(code, index) in selectedDtacGame">
                        <v-card-text :key="`game_${index}`">
                          <v-layout>
                            <v-flex class="pa-2">
                              {{ code.name }}
                            </v-flex>
                            <v-btn flat fab small class="ma-0" @click="deselectDtacGame(code.code)"
                              ><v-icon>close</v-icon></v-btn
                            >
                          </v-layout>
                        </v-card-text>
                        <v-divider
                          v-if="selectedDtacGame.length - 1 != index"
                          :key="'game_divider_' + index"
                        />
                      </template>
                    </v-card>
                  </template>
                </div>
                <div v-else>
                  <div v-if="coupon.category.length == 0" class="text-xs-center my-3">
                    {{ $t('coupon for all category') }}
                  </div>
                  <template v-else>
                    <v-card style="border: 1px solid #eee">
                      <template v-for="(cat, index) in coupon.category">
                        <v-card-text :key="'category_' + cat.id">
                          <v-layout>
                            <v-flex class="pa-2">
                              {{ cat.name }}
                            </v-flex>
                            <v-btn flat fab small class="ma-0" @click="deleteCategory(cat)"
                              ><v-icon>close</v-icon></v-btn
                            >
                          </v-layout>
                        </v-card-text>
                        <v-divider
                          v-if="coupon.category.length - 1 != index"
                          :key="'category_divider_' + cat.id"
                        />
                      </template>
                    </v-card>
                  </template>
                </div>
                <v-divider class="my-3" />
                <v-layout>
                  <v-flex>
                    {{ $t('Specific product') }}
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn
                      v-if="['dtac-gaming'].includes(selectedBot.type)"
                      :disabled="!(selectedDtacGame && selectedDtacGame.length > 0)"
                      small
                      outline
                      color="primary"
                      @click="handleShowProduct"
                    >
                      <v-icon class="mr-2">add</v-icon> {{ $t('Add') }}
                    </v-btn>
                    <v-btn v-else small outline color="primary" @click="handleShowProduct">
                      <v-icon class="mr-2">add</v-icon> {{ $t('Add') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
                <div v-if="['dtac-gaming'].includes(selectedBot.type)">
                  <div v-if="selectedDtacGameSku.length == 0" class="text-xs-center my-3">
                    coupon for all game
                  </div>
                  <template v-else>
                    <v-card style="border: 1px solid #eee">
                      <template v-for="(pro, index) in selectedDtacGameSku">
                        <v-card-text :key="`product_${index}`">
                          <v-layout>
                            <v-flex class="pa-2">
                              {{ pro.name }}
                            </v-flex>
                            <v-btn flat fab small class="ma-0" @click="deselectDtacGameSku(pro.id)"
                              ><v-icon>close</v-icon></v-btn
                            >
                          </v-layout>
                        </v-card-text>
                        <v-divider
                          v-if="selectedDtacGameSku.length - 1 != index"
                          :key="'product_divider_' + pro.id"
                        />
                      </template>
                    </v-card>
                  </template>
                </div>
                <div v-else>
                  <div v-if="exact_product_ids.length == 0" class="text-xs-center my-3">
                    {{ $t('coupon for all product') }}
                  </div>
                  <template v-else>
                    <v-card style="border: 1px solid #eee">
                      <template v-for="(pro, index) in exact_product_ids">
                        <v-card-text :key="'product_' + pro.id">
                          <v-layout>
                            <v-flex class="pa-2">
                              {{ pro.name }}
                            </v-flex>
                            <v-btn flat fab small class="ma-0" @click="deleteProduct(pro)"
                              ><v-icon>close</v-icon></v-btn
                            >
                          </v-layout>
                        </v-card-text>
                        <v-divider
                          v-if="exact_product_ids.length - 1 != index"
                          :key="'product_divider_' + pro.id"
                        />
                      </template>
                    </v-card>
                  </template>
                </div>
              </v-card>
              <v-btn color="primary" depressed @click="onsave">{{ $t('Save') }}</v-btn>
              <v-btn flat @click="step = 2">{{ $t('Back') }}</v-btn>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDtacGame" scrollable persistent max-width="1000">
      <v-card>
        <v-layout justify-end>
          <v-flex shrink class="text-xs-right">
            <v-btn small fab flat @click="showDtacGame = false"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-divider />
        <v-card-text max-height="600">
          <div class="mt-1 default-input">
            <v-text-field
              v-model="searchDtacGame"
              style="width: 50%"
              outline
              name="searchDtacGame"
              hide-details
              density="compact"
              :placeholder="$t('Search')"
            ></v-text-field>
          </div>
          <div class="text-xs-right">
            <v-pagination
              v-model="dtacGamePage"
              class="my-4"
              :length="dtacGameMaxPage"
              @input="changeDtacGamePage"
            ></v-pagination>
          </div>
          <div v-if="loadingDtacGame" class="text-xs-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <template v-if="filterDtacGame.length > 0">
            <div
              v-for="(game, index) in filterDtacGame"
              :key="'schedule_post_' + index"
              class="z-border-red"
              style="padding: 15px; margin-bottom: 15px; position: relative; cursor: pointer"
            >
              <v-layout>
                <v-flex>
                  <div style="padding-left: 10px; word-break: break-all">
                    {{ game.name }}
                  </div>
                </v-flex>

                <v-flex shrink>
                  <v-btn
                    small
                    depressed
                    :color="handleCheckDtacSelectedGame(game.code) ? '' : 'primary'"
                    :disabled="handleCheckDtacSelectedGame(game.code)"
                    @click="selectDtacGame(game)"
                  >
                    {{
                      handleCheckDtacSelectedGame(game.code) ? $t('game_selected') : $t('Select')
                    }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <div v-else class="text-xs-center">No category</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDtacGameSku" scrollable persistent max-width="1000">
      <v-card>
        <v-layout justify-end>
          <v-flex shrink class="text-xs-right">
            <v-btn small fab flat @click="showDtacGameSku = false"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-divider />
        <v-card-text max-height="600">
          <div class="mt-1 mb-3 default-input">
            <v-text-field
              v-model="searchDtacSku"
              style="width: 50%"
              outline
              name="name"
              hide-details
              density="compact"
              :placeholder="$t('Search')"
            ></v-text-field>
          </div>
          <div v-if="loadingDtacSkuGame" class="text-xs-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <template v-if="filterDtacGameSku.length > 0">
            <div
              v-for="(game, index) in filterDtacGameSku"
              :key="'schedule_post_' + index"
              class="z-border-red"
              style="padding: 15px; margin-bottom: 15px; position: relative; cursor: pointer"
            >
              <v-layout>
                <v-flex>
                  <div style="padding-left: 10px; word-break: break-all">
                    {{ game.name }}
                  </div>
                </v-flex>

                <v-flex shrink>
                  <v-btn
                    small
                    depressed
                    :color="handleCheckDtacSelectedGameSku(game.sku) ? '' : 'primary'"
                    :disabled="handleCheckDtacSelectedGameSku(game.sku)"
                    @click="selectDtacGameSku(game)"
                  >
                    {{
                      handleCheckDtacSelectedGameSku(game.sku) ? $t('game_selected') : $t('Select')
                    }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <div v-else class="text-xs-center">No category</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showCategory" scrollable persistent max-width="1000">
      <v-card>
        <v-layout>
          <v-flex class="pa-1 form-control">
            <input v-model="search" type="text" :placeholder="$t('Search')" class="mb-0" />
          </v-flex>
          <v-flex shrink class="text-xs-right">
            <v-btn small fab flat @click="showCategory = false"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-divider />
        <v-card-text max-height="600">
          <div v-if="loadingCategory" class="text-xs-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <template v-if="filterCategory.length > 0">
            <div
              v-for="(cat, index) in filterCategory"
              :key="'schedule_post_' + index"
              class="z-border-red"
              style="padding: 15px; margin-bottom: 15px; position: relative; cursor: pointer"
            >
              <v-layout>
                <v-flex>
                  <div style="padding-left: 10px; word-break: break-all">
                    {{ cat.name }}
                  </div>
                </v-flex>

                <v-flex shrink>
                  <v-btn small depressed @click="selectedCategory(cat)">
                    {{ $t('Select') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </template>
          <div v-else class="text-xs-center">No category</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showProducts" scrollable persistent max-width="1000">
      <Products
        v-if="showProducts"
        :exact-product-ids="exact_product_ids"
        @handleCloseDialog="showProducts = false"
        @handleSelectProduct="selectedProducts"
      />
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Products from './coupon/Products'
import SelectGiftStock from './GiftStockControl/SelectGiftStock'
import dtacGamingApi from '@/api/dtac-gaming'

const dict = {
  en: {
    custom: {
      couponcode: {
        excluded: 'Duplicate Conversation Name'
      }
    }
  },
  th: {
    custom: {
      couponcode: {
        excluded: 'ชื่อบทสนทนาซ้ำ'
      }
    }
  },
  la: {
    custom: {
      couponcode: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ'
      }
    }
  }
}

export default {
  components: {
    Multiselect,
    ToggleButton,
    Products,
    SelectGiftStock
  },
  props: ['value', 'currentcoupon', 'coupons'],
  data() {
    let optionsHours = [],
      optionsMinute = []
    for (let index = 0; index <= 24; index++) {
      optionsHours.push(index.toString().padStart(2, '0'))
    }
    for (let index = 0; index <= 60; index++) {
      optionsMinute.push(index.toString().padStart(2, '0'))
    }
    return {
      optionsHours: optionsHours,
      optionsMinute: optionsMinute,
      exact_product_ids: [],
      giveaway_product_ids: [],
      startDate: null,
      startTimeHours: '00',
      startTimeMinute: '00',
      endTimeHours: '00',
      endTimeMinute: '00',
      openStartDate: false,
      openStartTime: false,
      endDate: null,
      openEndDate: false,
      openEndTime: false,
      showDtacGame: false,
      showDtacGameSku: false,
      showCategory: false,
      showProducts: false,
      step: 1,
      search: '',
      promotypeOptions: ['price', 'piece'],
      discounttypeOptions: ['price', 'percent', 'ship', 'freeship', 'giveaway'],
      coupon: {
        name: '', //
        code: '',
        promotype: 'price', // price or piece
        promovalue: 5, // numeric
        discounttype: 'price', // price,percent,ship,freeship,giveaway
        discountvalue: '100', // numeric
        onetimeuse: true, // true,false
        category: [], // [{id:17465,name:"sadsad"},{....}]
        exact_product_ids: null,
        giveaway_product_ids: [],
        quantity: null, // limit 999
        status: true, // true,false
        is_hidden: false,
        first_time_purchase: false,
        limit_used_per_user: 1
      },
      selectedFreeProducts: [],
      dtacGameData: [],
      dtacGameSku: [],
      loadingDtacGame: false,
      loadingDtacSkuGame: false,
      dtacGamePage: 1,
      dtacGameMaxPage: 1,
      selectedDtacGame: [],
      selectedDtacGameSku: [],
      searchDtacSku: '',
      searchDtacGame: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory',
      products: 'getProducts'
    }),
    filterCategory() {
      if (!this.categories || this.categories.length == 0) return []
      var category = this.categories.filter((el) => {
        return (
          !this.coupon ||
          !this.coupon.category ||
          this.coupon.category.length == 0 ||
          this.coupon.category.findIndex((cat) => {
            return el.id == cat.id
          }) == -1
        )
      })

      if (this.search != '') {
        return category.filter((el) => {
          return el.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return category
      }
    },

    filterProducts() {
      if (!this.products || this.products.length == 0) return []
      var products = this.products.filter((el) => {
        return (
          !this.exact_product_ids ||
          this.exact_product_ids.length == 0 ||
          this.exact_product_ids.findIndex((pro) => {
            return el.id == pro.id
          }) == -1
        )
      })

      if (this.search != '') {
        return products.filter((el) => {
          return el.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return products
      }
    },
    excludeCoupons() {
      var coupons = this.coupons

      if (this.coupon && this.coupon.id) {
        coupons = coupons.filter((el) => {
          return this.coupon.id != el.id
        })
      }

      if (coupons.length == 0) {
        return ''
      }

      return coupons
        .map((el) => {
          return el.code
        })
        .join(',')
    },
    filterDtacGameSku() {
      const vm = this
      if (vm.searchDtacSku) {
        const tempData = vm.dtacGameSku.filter(
          (x) => x.name && x.name.toLowerCase().match(vm.searchDtacSku.toLowerCase())
        )
        return tempData
      } else {
        return vm.dtacGameSku
      }
    },
    filterDtacGame() {
      const vm = this
      if (vm.searchDtacGame) {
        const tempData = vm.dtacGameData.filter(
          (x) => x.name && x.name.toLowerCase().match(vm.searchDtacGame.toLowerCase())
        )
        return tempData
      } else {
        return vm.dtacGameData
      }
    }
  },
  mounted() {
    this.$validator.localize(dict)
    if (this.currentcoupon) {
      var coupon = this.currentcoupon
      try {
        coupon.category = JSON.parse(coupon.category)
      } catch (error) {
        console.error(error)
      }
      this.coupon = coupon
      this.startDate =
        this.coupon.startdate !== null ? moment(this.coupon.startdate).format('YYYY-MM-DD') : null
      this.startTimeHours =
        this.coupon.startdate !== null ? moment(this.coupon.startdate).format('HH') : '00'
      this.startTimeMinute =
        this.coupon.startdate !== null ? moment(this.coupon.startdate).format('mm') : '00'
      this.endDate =
        this.coupon.enddate !== null ? moment(this.coupon.enddate).format('YYYY-MM-DD') : null
      this.endTimeHours =
        this.coupon.enddate !== null ? moment(this.coupon.enddate).format('HH') : '00'
      this.endTimeMinute =
        this.coupon.enddate !== null ? moment(this.coupon.enddate).format('mm') : '00'
      this.exact_product_ids = coupon.exact_product_ids
        ? this.getProductById(coupon.exact_product_ids)
        : []
      this.giveaway_product_ids = coupon.giveaway_product_ids
        ? coupon.giveaway_product_ids
            .split(',')
            .map((el) => el && parseInt(el))
            .filter((el) => el)
        : []

      if (['dtac-gaming'].includes(this.selectedBot.type)) {
        this.selectedDtacGame = this.coupon.gaming_nation_cns_game_code
        this.selectedDtacGameSku = this.coupon.gaming_nation_cns_game_sku
      }
    } else if (this.selectedBot.type == 'dtac-gaming') {
      this.coupon.promovalue = 0
    }
  },

  filters: {
    capitalize(name) {
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    }
  },
  methods: {
    changeDtacGamePage(page) {
      this.dtacGamePage = page
      this.getDtacGame()
    },
    selectDtacGame(game) {
      let tempData = this.selectedDtacGame
      if (!tempData.find((x) => x.code === game.code)) {
        tempData.push(game)
        this.selectedDtacGame = tempData
      }
    },
    selectDtacGameSku(game) {
      let tempData = this.selectedDtacGameSku
      if (!tempData.find((x) => x.id === game.id)) {
        tempData.push(game)
        this.selectedDtacGameSku = tempData
      }
    },

    async handleShowProduct() {
      if (['dtac-gaming'].includes(this.selectedBot.type)) {
        if (this.selectedDtacGame && this.selectedDtacGame.length) {
          this.showDtacGameSku = true
          await this.getDtacGameSku()
        }
      } else {
        this.showProducts = true
      }
    },
    async handleAddCategory() {
      if (['dtac-gaming'].includes(this.selectedBot.type)) {
        try {
          this.showDtacGame = true
          await this.getDtacGame()
        } catch (error) {
          console.error(error)
        }
      } else {
        this.showCategory = true
      }
    },
    async getDtacGame() {
      try {
        this.loadingDtacGame = true
        this.dtacGameData = []
        const response = await dtacGamingApi.getGamesCode(
          this.selectedBot.pageid,
          this.dtacGamePage
        )
        if (response.data.games.data.records && response.data.games.data.pagination) {
          this.dtacGameMaxPage = response.data.games.data.pagination.last_page
          this.dtacGameData = response.data.games.data.records
        }
        return
      } catch (error) {
        throw error
      } finally {
        this.loadingDtacGame = false
      }
    },
    async getDtacGameSku() {
      try {
        const vm = this
        vm.loadingDtacSkuGame = true
        vm.dtacGameSku = []
        vm.selectedDtacGame.forEach(async (code) => {
          const response = await dtacGamingApi.getGamesCodeSku(vm.selectedBot.pageid, code.code)

          if (
            response &&
            response.data &&
            response.data.data &&
            response.data.data.data &&
            response.data.data.data.variants
          ) {
            const tempData = response.data.data.data.variants.map((x) => {
              return { game_code: code.code, ...x }
            })
            vm.dtacGameSku.push(...tempData)
          }
        })
        return
      } catch (error) {
        throw error
      } finally {
        this.loadingDtacSkuGame = false
      }
    },
    handleCheckDtacSelectedGame(code) {
      if (this.selectedDtacGame && this.selectedDtacGame.length > 0) {
        const allSelectedGame = this.selectedDtacGame.map((game) => game.code)
        return allSelectedGame.includes(code)
      } else {
        return false
      }
    },
    handleCheckDtacSelectedGameSku(sku) {
      if (this.selectedDtacGameSku && this.selectedDtacGameSku.length > 0) {
        const allSelectedGameSku = this.selectedDtacGameSku.map((game) => game.sku)
        return allSelectedGameSku.includes(sku)
      } else {
        return false
      }
    },

    getProductById(id) {
      var array = id.split(',')
      var products = this.products.filter((product) => {
        return (
          array.findIndex((pro) => {
            return product.id == pro
          }) !== -1
        )
      })
      return products
    },
    onBlurCode() {
      this.$set(this.coupon, 'code', this.coupon.code.toUpperCase())
    },
    async nextStep(step) {
      var result = await this.$validator.validateAll()
      if (!result) {
        this.goToErrorInput()
        return false
      }

      this.step = step
    },
    deselectDtacGameSku(code) {
      const index = this.selectedDtacGameSku.findIndex((el) => {
        return el.id == code
      })
      if (index != -1) this.selectedDtacGameSku.splice(index, 1)
    },
    deselectDtacGame(code) {
      const index = this.selectedDtacGame.findIndex((el) => {
        return el.code == code
      })
      if (index != -1) this.selectedDtacGame.splice(index, 1)
    },
    deleteCategory(category) {
      var index = this.coupon.category.findIndex((el) => {
        return el.id == category.id
      })
      if (index != -1) this.coupon.category.splice(index, 1)
    },
    deleteProduct(product) {
      var index = this.exact_product_ids.findIndex((el) => {
        return el.id == product.id
      })
      if (index != -1) this.exact_product_ids.splice(index, 1)
    },
    selectedCategory(category) {
      this.coupon.category.push(category)
    },
    selectedProducts(product) {
      this.exact_product_ids.push(product)
    },

    onlyIDexactProduct(exact_product_ids) {
      var a = []
      exact_product_ids.map((item) => {
        a.push(item.id)
      })
      return a.toString()
    },
    onsave() {
      if (
        this.startDate !== null &&
        this.startTimeHours !== null &&
        this.startTimeMinute !== null
      ) {
        this.$set(
          this.coupon,
          'startdate',
          `${this.startDate} ${this.startTimeHours}:${this.startTimeMinute}:00`
        )
      } else {
        if (this.startDate !== null) {
          this.$set(this.coupon, 'startdate', `${this.startDate} 00:00:00`)
        } else {
          this.$set(this.coupon, 'startdate', null)
        }
      }

      if (this.endDate !== null && this.endTimeHours !== null && this.endTimeMinute !== null) {
        this.$set(
          this.coupon,
          'enddate',
          `${this.endDate} ${this.endTimeHours}:${this.endTimeMinute}:00`
        )
      } else {
        if (this.endDate !== null) {
          this.$set(this.coupon, 'enddate', `${this.endDate} 00:00:00`)
        } else {
          this.$set(this.coupon, 'enddate', null)
        }
      }

      this.$set(this.coupon, 'exact_product_ids', this.onlyIDexactProduct(this.exact_product_ids))
      this.$set(this.coupon, 'giveaway_product_ids', this.giveaway_product_ids.toString())
      this.$set(this.coupon, 'code', this.coupon.code.toUpperCase())
      this.$set(this.coupon, 'gaming_nation_cns_game_code', this.selectedDtacGame)
      this.$set(this.coupon, 'gaming_nation_cns_game_sku', this.selectedDtacGameSku)
      this.$emit('onsave', this.coupon)
      this.coupon = {
        name: '', //
        code: '',
        promotype: 'price', // price or piece
        promovalue: 5, // numeric
        discounttype: 'price', // price,percent,ship,freeship,giveaway
        discountvalue: '100', // numeric
        onetimeuse: true, // true,false
        category: [], // [{id:17465,name:"sadsad"},{....}]
        exact_product_ids: null,
        giveaway_product_ids: [],
        quantity: null, // limit 999
        status: true, // true,false
        startdate: null,
        enddate: null,
        is_hidden: false,
        first_time_purchase: false
      }
      this.errors.clear()
      this.step = 1
      this.$emit('input', false)
    },
    oncancel() {
      this.coupon = {
        name: '', //
        code: '',
        promotype: 'price', // price or piece
        promovalue: 5, // numeric
        discounttype: 'price', // price,percent,ship,freeship,giveaway
        discountvalue: '100', // numeric
        onetimeuse: true, // true,false
        category: [], // [{id:17465,name:"sadsad"},{....}]
        exact_product_ids: null,
        giveaway_product_ids: [],
        quantity: null, // limit 999
        status: true, // true,false
        startdate: null,
        enddate: null,
        is_hidden: false,
        first_time_purchase: false
      }
      this.errors.clear()
      this.step = 1
      this.$emit('input', false)
    },
    onKeyPress(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        (charCode < 65 || charCode > 90) &&
        (charCode < 97 || charCode > 122)
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AddCoupon.vue